import type { ComponentPropsWithRef, ReactNode } from "react";
import { cn } from "@/lib/utils";
import { type FieldSize, fieldChrome } from "./field-chrome";

interface Chrome {
  size?: FieldSize;
  children?: ReactNode;
}

export type SelectProps = Chrome &
  Omit<ComponentPropsWithRef<"select">, keyof Chrome>;

/**
 * The field an attorney chooses a value in. Four screens rolled their own and
 * agreed on nothing; only one of the four said it could be clicked.
 *
 * Native rather than a listbox of our own: every one of them was a `<select>`,
 * none needed multi-select or search, and the browser's control is the one an
 * attorney's keyboard and screen reader already know. A richer one is a
 * different component, added when a screen needs it rather than in advance.
 */
export function Select({ size, className, children, ...rest }: SelectProps) {
  return (
    <select
      className={cn(fieldChrome(size), "cursor-pointer", className)}
      {...rest}
    >
      {children}
    </select>
  );
}
